import { useState, useEffect } from "react";
import { getProviderSMSConversation } from "apiHandler/actions";
import { useUserData } from "components/customHooks/userDataContext";

import Messages from "./Messages";
import Input from "./Input";

const Chat = (props) => {
  const [oldChat, setoldChat] = useState([]);
  const userData = useUserData();
  const token = userData?.access_token;

  const fetchMessages = async () => {
    props.setShow(true);
    const payload = {
      practice_id: userData.selected_practice,
      participant_number: props.provider_phone_mobile?.toString(),
    };
    const chat = await getProviderSMSConversation(payload, token);
    setoldChat(chat ? chat.messages : []);
    props.setShow(false);
  };

  useEffect(() => {
    fetchMessages();
    // eslint-disable-next-line
  }, [props.provider_phone_mobile]);

  return (
    <>
      {props.provider_phone_mobile ? (
        <div className="chat">
          <div className="chatInfo" style={{ backgroundColor: props.color }}>
            <p style={{ textAlign: "center" }}>
              {props.first_name +
                " " +
                props.last_name +
                "  " +
                props.provider_phone_mobile}
            </p>
          </div>
          <Messages oldChat={oldChat} colorData={props.color} />
          <Input {...props} userData={userData} fetchMessages={fetchMessages} />
        </div>
      ) : (
        <div className="chat">
          <div className="chatInfo">
            <p style={{ textAlign: "center" }}></p>
          </div>
          <Messages data={props.provider_phone_mobile} oldChat={oldChat} />
          <Input {...props} userData={userData} fetchMessages={fetchMessages} />
        </div>
      )}
    </>
  );
};

export default Chat;
